export enum CalendarModes {
  WEEK,
  DAY,
}
